import "./Tabs.scss";
export default (props) => {
  const cls = props.className? props.className : "";
  return (
    <nav>
      <ul {...props} className={`Tabs ${cls}`}>{props.children}</ul>
    </nav>
  );
};
